import * as Yup from 'yup';
import { useTranslation } from 'react-i18next';
import { EMAIL } from '##/utils/validation';

export type FormValues = {
  email: string | null;
};

export const useForm = () => {
  const { t } = useTranslation();
  const initialValues: FormValues = {
    email: null,
  };

  const schema = Yup.object().shape({
    email: EMAIL(t).nullable(),
  });

  return {
    initialValues,
    schema,
  };
};
